module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/issue-main-300x300.e4c82b2c.jpg";